export default "__VITE_ASSET__tis8YMts__"